// extracted by mini-css-extract-plugin
export default {"error_div":"error_error_div__po4Gu"};